export default __webpack_public_path__ + "boogo_logo.0fba4732.svg";